import t from "./index762.js";
import { withInstall as o } from "./index604.js";
const m = o(t);
export {
  m as ElTeleport,
  m as default
};
